import type {
  BuildId,
  MacCpuArch,
  OS,
  WindowsCpuArch,
} from "@/lib/platform";

export const BUILD_ORDER: BuildId[] = [
  "win-x64",
  "win-arm64",
  "mac-silicon",
  "mac-intel",
];

export const CROSS_PLATFORM_DEFAULT: Record<BuildId, BuildId> = {
  "win-x64": "mac-silicon",
  "win-arm64": "mac-silicon",
  "mac-silicon": "win-x64",
  "mac-intel": "win-x64",
};

export type DownloadLayout = {
  matchBuild: BuildId | null;
  primaryFirst: BuildId;
  primarySecond: BuildId;
  moreBuilds: BuildId[];
};

export function computeDownloadLayout(
  os: OS,
  windowsCpuArch: WindowsCpuArch,
  macCpuArch: MacCpuArch,
): DownloadLayout {
  let matchBuild: BuildId | null = null;
  if (os === "windows") {
    if (windowsCpuArch === "arm64") matchBuild = "win-arm64";
    else if (windowsCpuArch === "x64") matchBuild = "win-x64";
    else matchBuild = "win-x64";
  } else if (os === "macos") {
    if (macCpuArch === "x64") matchBuild = "mac-intel";
    else if (macCpuArch === "arm64") matchBuild = "mac-silicon";
    else matchBuild = "mac-silicon";
  }

  let primaryFirst: BuildId;
  let primarySecond: BuildId;
  if (!matchBuild) {
    primaryFirst = "win-x64";
    primarySecond = "mac-silicon";
  } else {
    primaryFirst = matchBuild;
    primarySecond = CROSS_PLATFORM_DEFAULT[matchBuild];
  }

  const moreBuilds = BUILD_ORDER.filter(
    (id) => id !== primaryFirst && id !== primarySecond,
  );

  return { matchBuild, primaryFirst, primarySecond, moreBuilds };
}
